export default "__VITE_ASSET__Bhow4ulk__"